<script>
	import { Pie, mixins } from 'vue-chartjs';
	const { reactiveProp } = mixins;

	/**
     * @module PieChart
     * 
	 * @vue-data {object} [chartOptions={ response: true, maintainAspectRatio: false, legend: { position: right, align: start } }] - Set chart options
	 * @vue-data {boolean} [chartOptions.responsive=false] - Resizes the chart canvas when its container does
	 * @vue-data {boolean} [chartOptions.maintainAspectRatio=false] - Maintain the original canvas aspect ratio (width / height) when resizing
	 * @vue-data {object} [chartOptions.legend={}] - Legend options
	 * @vue-data {string} [chartOptions.legend.position={}] - Position of the legend
	 * @vue-data {string} [chartOptions.legend.align={}] - Alignment of the legend
	 */

	export default {
		extends: Pie,

		// reactiveProp will automatically create chartData as a prop or data and add a watcher
		// If data has changed, the chart will update
		mixins: [reactiveProp],
		data() {
			return {
				chartOptions: {
					responsive: true,
					maintainAspectRatio: false,
					legend: {
						position: 'right',
						align: 'start',
					},
				},
			};
		},
		mounted() {
			// this.chartData is created in the mixin
			this.renderChart(this.chartData, this.chartOptions);
		},
	};
</script>
